import { ExportOutlined } from '@ant-design/icons';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';
import { getLocale } from 'translations/locale';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useIndicatorAnalyzeFilters } from 'business/shift-report/indicators/pages/indicator-analyze/providers/filters';
import { useLegendFilters } from 'business/shift-report/indicators/pages/indicator-analyze/providers/legend-filters';
import { getCurrentAnalysisType } from 'business/shift-report/indicators/pages/indicator-analyze/services/get-current-analysis-type';
import { useAvailableIndicatorSelection } from 'business/shift-report/indicators/pages/Indicators/service';
import { getFetchRange } from 'technical/range-filters/get-fetch-range';
import Button from 'ui/button';

import { useIndicatorAnalyzeExport } from './use-indicator-analyze-export';

export const IndicatorAnalyzeExportButton = () => {
  const { currentConstructionSiteId } = useAppContext();
  invariant(currentConstructionSiteId, 'No constructionSite id');

  const { t } = useTranslation();

  const filters = useIndicatorAnalyzeFilters();
  const { legendFilters } = useLegendFilters();

  const indicators = useAvailableIndicatorSelection(currentConstructionSiteId);

  const analysisType = getCurrentAnalysisType(
    filters.filterType,
    filters.groupByType,
  );

  const { generateExport, isPending } = useIndicatorAnalyzeExport();
  const fetchRange = getFetchRange(filters);

  const onClick = () => {
    generateExport({
      body: {
        constructionSiteId: currentConstructionSiteId,
        analysisType,
        indicatorIds: indicators.list.map(({ key }) => key),
        locale: getLocale(),
        selectedIndicatorIds: legendFilters.allIndicators
          ? indicators.list.map(({ key }) => key)
          : legendFilters.selectedIndicators,
        ...fetchRange,
      },
    });
  };

  return (
    <Button icon={<ExportOutlined />} onClick={onClick} loading={isPending}>
      {t('common.export')}
    </Button>
  );
};
